import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Box, Fab, makeStyles } from "@material-ui/core";
import { ClassNameMap } from '@material-ui/styles';
import ActionConfirmationDialog from './ActionConfirmationDialog';
import { useState } from 'react';

interface Props {
  createEnabled: boolean;
  deleteEnabled: boolean;
  editEnabled: boolean;
  deleteRequiresConfirmation?: boolean
  onAdd: () => void;
  onDelete: () => void;
  onEdit: () => void;
  renderCustomButtons?: (classes: ClassNameMap) => JSX.Element;
}

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1)
  }
}));

const ButtonsPanel = (props: Props) => {
  const classes = useStyles();
  const isCreateDisabled = !props.createEnabled;
  const editDisabled = !props.editEnabled;
  const deleteDisabled = !props.deleteEnabled;
  const [isDeleteConfirmationDialogOpen, setDeleteConfirmationDialogOpen] = useState<boolean>(false);

  const showDeleteConfirmationDialog = () => setDeleteConfirmationDialogOpen(true);
  const hideDeleteConfirmationDialog = () => setDeleteConfirmationDialogOpen(false);

  return (
    <Box display="flex" flexDirection="row" justifyContent="flex-end">
      <Fab
          aria-label="add"
          color="default"
          disabled={isCreateDisabled}
          className={classes.button}
          onClick={props.onAdd}
          size="medium"
      >
        <AddIcon />
      </Fab>
      <Fab
          aria-label="edit"
          color="primary"
          disabled={editDisabled}
          className={classes.button}
          onClick={props.onEdit}
          size="medium"
      >
        <EditIcon />
      </Fab>
      <Fab
          aria-label="delete"
          color="secondary"
          disabled={deleteDisabled}
          className={classes.button}
          onClick={props.deleteRequiresConfirmation ? showDeleteConfirmationDialog : props.onDelete}
          size="medium"
      >
        <DeleteIcon />
      </Fab>
      { props.renderCustomButtons && props.renderCustomButtons(classes) }
      <ActionConfirmationDialog
        open={isDeleteConfirmationDialogOpen}
        message='Czy na pewno chcesz usunąć ten wpis?'
        confirmButtonLabel='Usuń'
        cancelButtonLabel='Zrezygnuj'
        onConfirm={props.onDelete}
        onCancel={hideDeleteConfirmationDialog}
      />
    </Box>
  );
};
export default ButtonsPanel;